import React, { useEffect } from 'react'
import { getLogsData } from '../../actions/dashboard'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../../components/Loader'
import Table from '../../components/Table'
import moment from 'moment'

const Logs = () => {
  
  const dispatch = useDispatch()
  const { logs, loading } = useSelector(state => state.dashboard)


  useEffect(() => {
    dispatch(getLogsData())
  }, [dispatch])
  
  if (loading) return <Loader/>;

  const renderLog = (item) => {
    const time = moment(item.time).format('DD.MM.YYYY HH:mm:ss')
    
    return (
      <tr key={item.id}>
        <td>{item.name}</td>
        <td>{item.server}</td>
        <td>{time}</td>
        <td>{item.message}</td>
      </tr>
    )
  }

  return (
    <section>
      <Table maxHeight='90vh'>
        <thead>
          <tr>
            <th>Школа</th>
            <th>Сервер</th>
            <th>Время</th>
            <th>Сообщение</th>
          </tr>
        </thead>
        <tbody>
          {logs?.map(renderLog)}
        </tbody>
      </Table>
    </section>
  )
}

export default Logs